// @ts-nocheck
// ==========================================
// 1. REACT & EXTERNE BIBLIOTHEKEN
// ==========================================
import React, { useState, useEffect } from 'react';
import { 
  Layout, Plus, Users, Settings, Search, Activity, Euro, Save, Scissors, 
  Sparkles, Loader2, Database, Trash2, Pencil, X, Cloud, Tag, ClipboardCopy, 
  ChevronDown, Archive, CheckCircle2, Clock, ArrowLeft, User, 
  Menu as MenuIcon, LogOut, AlertTriangle, Calendar, Edit3, Merge, Filter,
  Moon, Sun, ArrowUpDown, Download, Printer, Repeat, CreditCard, Link, Bell, Briefcase, TrendingUp
} from 'lucide-react';

// ==========================================
// 2. CORE & CONFIGURATIE (Set & Forget)
// (Config, Hooks, authenticatie, foutafhandeling)
// ==========================================
// NIEUW: storage toegevoegd aan de import
import { db, auth, firebaseInitialized, firebaseError, appId, storage } from './constants/firebase';
import { doc, setDoc, addDoc, collection, updateDoc, deleteDoc, writeBatch, getDoc } from 'firebase/firestore';
// NIEUW: Firebase storage functies toegevoegd
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

import { useTheme } from './hooks/useTheme';
import { useAuth } from './hooks/useAuth';
import { useFirestore } from './hooks/useFirestore';
import ErrorBoundary from './components/ErrorBoundary';
import LoginScreen from './components/LoginScreen';

// ==========================================
// 3. UTILS & HULPFUNCTIES
// ==========================================
import { formatPrice, formatDateEU, formatAgendaDay, parseDutchPrice, getCategoryColor } from './utils/formatters';

// ==========================================
// 4. PAGINA'S & SCHERMEN (Day-to-day werk)
// (Hier pas je features, UI en schermen aan)
// ==========================================

// --- HOOFDSCHERMEN (Werklijsten & Archief) ---
import DashboardView from './components/DashboardView';           // Het startscherm met de actieve rackets en de 'Nieuw -> Bezig -> Klaar' workflow.
import AllJobsView from './components/AllJobsView';               // Het archief met alle afgeronde bespanningen uit het verleden (met zoek/filter functies).
import StatisticsView from './components/StatisticsView';         // Het overzicht van de statistieken: omzet, aantal bespanningen, gemiddelde prijs, etc.
import ReservationView from './components/ReservationView';

// --- KLANTEN & INVOER ---
import NewJobView from './components/NewJobView';                 // Het formulier ('Nieuwe Opdracht') om handmatig een bespanning in te voeren.
import CustomersView from './components/CustomersView';           // De complete klantenlijst (adresboek), inclusief het samenvoegen of bewerken van klanten.
import CustomerHistoryView from './components/CustomerHistoryView'; // Het individuele dossier van één specifieke klant (met hun vorige rackets en testrackets).

// --- KLANTENPORTAAL (Online Aanvragen) ---
import IntakeForm from './components/IntakeForm';                 // De openbare '/aanmelden' pagina waar klanten zélf online hun racket kunnen aanmelden.
import InboxView from './components/InboxView';                   // Het scherm waar de online aanvragen binnenkomen zodat jij ze kunt accepteren.

// --- INVENTARIS & BEHEER ---
import InventoryView from './components/InventoryView';           // De voorraadkast: beheer van snaren, grips en dempers (inclusief import/export van Excel).
import TestracketsView from './components/TestracketsView';       // Beheer van de testrackets en het verhuren/uitlenen hiervan aan klanten.
import StringerPortalView from './components/StringerPortalView'; // Het dossier per bespanner: overzicht van gemaakte rackets en openstaande uitbetalingen.
import SettingsView from './components/SettingsView';             // Instellingen: bedrijfsgegevens, Mollie API sleutel, en bespanners toevoegen/verwijderen.

// --- GLOBALE MODALS (Pop-ups voor specifieke acties) ---
import JobEditModal from './components/JobEditModal';             // Pop-up formulier om de details (kilo's, snaar, prijs) van een bestaande opdracht te wijzigen.
import ItemEditModal from './components/ItemEditModal';           // Pop-up formulier om een nieuw voorraad-item (zoals een snaar) toe te voegen of aan te passen.
import PaymentModal from './components/PaymentModal';             // Pop-up die het WhatsApp-betaalverzoek inclusief de gegenereerde Mollie-link toont.
import PrintModal from './components/PrintModal';                 // Pop-up om de 12mm (Dymo) sticker te printen, inclusief de keuze voor het merk-logo.

  // --- MAIN APP COMPONENT ---
function AppContent() {
  const [activeTab, setActiveTab] = useState('dashboard');
  
  // 1. Haal de logica uit onze nieuwe hooks!
  const { darkMode, toggleTheme } = useTheme();
  const { user, loading, handleGoogleLogin, logout } = useAuth();

  // Klein extraatje om ervoor te zorgen dat je tabblad reset na uitloggen
  const handleLogout = async () => {
      await logout();
      setActiveTab('dashboard');
  };

// --- DATA SYNC (Custom Hook) ---
  const {
    customers, setCustomers,
    inventory, setInventory,
    jobs, setJobs,
    stringers, setStringers,
    testrackets, setTestrackets,
    inbox, setInbox,
    userProfile, setUserProfile,
    draftCompanyName, setDraftCompanyName,
    customLinkId, setCustomLinkId,
    draftLinkId, setDraftLinkId
  } = useFirestore(user);
  
  // --- FORMULIER INSTELLINGEN ---
  const [formSettings, setFormSettings] = useState({
      askAddress: false,
      askClub: true,
      askCurrentString: false,
      allowMultipleRackets: true
  });

  // 1. Haal ze uit je profiel als de app laadt
  useEffect(() => {
      if (userProfile && userProfile.formSettings) {
          setFormSettings(userProfile.formSettings);
      }
  }, [userProfile]);

  // 2. Functie om direct op te slaan in Firebase zodra je een knop omzet
const updateFormSettings = async (newSettings: any) => {
    // 1. Zien we de klik binnenkomen?
    console.log("🔄 Klik geregistreerd! Nieuwe instellingen:", newSettings);
    
    // 2. Direct updaten op het scherm
    setFormSettings(newSettings); 
    
    // 3. Checken of de gebruiker wel echt bestaat op dit moment
    if (!user || !user.uid) {
        console.error("❌ FOUT: Geen user gevonden. Opslaan afgebroken.");
        alert("Kan niet opslaan: Het systeem weet even niet wie je bent (geen user ID).");
        return;
    }
    
    try {
        console.log(`⏳ Opslaan in database voor user: ${user.uid}...`);
        
        // 4. De daadwerkelijke save
        await setDoc(doc(db, 'artifacts', appId, 'users', user.uid), {
            formSettings: newSettings
        }, { merge: true }); 
        
        console.log("✅ Succesvol opgeslagen in Firebase!");
    } catch (err) {
        console.error("❌ Database Fout:", err);
        alert("Er ging iets mis met opslaan in de database. Bekijk de console (F12).");
    }
};

  // --- STATE ---
  const [searchQuery, setSearchQuery] = useState('');
  const [editingItem, setEditingItem] = useState(null); 
  const [showImportModal, setShowImportModal] = useState(false); 
  const [showCustomerImportModal, setShowCustomerImportModal] = useState(false); 
  const [showJobImportModal, setShowJobImportModal] = useState(false); 
  const [isProcessingImport, setIsProcessingImport] = useState(false);
  const [importText, setImportText] = useState('');
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [showGlobalSearchDropdown, setShowGlobalSearchDropdown] = useState(false);
  const [selectedCustomerForHistory, setSelectedCustomerForHistory] = useState(null);
  
  // Bulk selectie & Merge state
  const [selectedCustomerIds, setSelectedCustomerIds] = useState(new Set());
  const [selectedJobIds, setSelectedJobIds] = useState(new Set());
  const [selectedInventoryIds, setSelectedInventoryIds] = useState(new Set()); 
  const [inventoryFilter, setInventoryFilter] = useState('Alle'); 
  const [inventorySearch, setInventorySearch] = useState('');

  // Sorteer Configs
  const [customerHistorySortConfig, setCustomerHistorySortConfig] = useState({ key: 'date', direction: 'descending' });
  const [stringerSortConfig, setStringerSortConfig] = useState({ key: 'date', direction: 'descending' });

  const [isEditingCustomer, setIsEditingCustomer] = useState(false); 
  const [editingCustomerData, setEditingCustomerData] = useState(null); 
  const [editingJob, setEditingJob] = useState(null); 
  const [duplicateGroups, setDuplicateGroups] = useState([]);
  const [duplicateInventoryGroups, setDuplicateInventoryGroups] = useState([]); 

  // String Search State (Main)
  const [stringSearchTerm, setStringSearchTerm] = useState('');
  const [showStringDropdown, setShowStringDropdown] = useState(false);

  // String Search State (Cross / Breedte)
  const [crossStringSearchTerm, setCrossStringSearchTerm] = useState('');
  const [showCrossStringDropdown, setShowCrossStringDropdown] = useState(false);

  // Print State
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [jobsToPrint, setJobsToPrint] = useState([]); 

// Settings Accordion State
  const [settingsOpenMenu, setSettingsOpenMenu] = useState('company'); // 'company', 'stringers', 'mollie', or null
  const [newStringerName, setNewStringerName] = useState('');
  const [mollieLiveKey, setMollieLiveKey] = useState(localStorage.getItem('mollieLiveKey') || localStorage.getItem('mollieApiKey') || '');
  const [mollieTestKey, setMollieTestKey] = useState(localStorage.getItem('mollieTestKey') || '');
  const [generatingMollieId, setGeneratingMollieId] = useState(null);

  // Haal de beveiligde keys op uit Firestore als de app start
  useEffect(() => {
      const fetchMollieKeys = async () => {
          if (!user) return;
          try {
              const snap = await getDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'private_settings', 'mollie'));
              if (snap.exists()) {
                  const data = snap.data();
                  if (data.liveKey) {
                      setMollieLiveKey(data.liveKey);
                      localStorage.setItem('mollieLiveKey', data.liveKey);
                  }
                  if (data.testKey) {
                      setMollieTestKey(data.testKey);
                      localStorage.setItem('mollieTestKey', data.testKey);
                  }
              }
          } catch (error) {
              console.error("Kon Mollie keys niet ophalen:", error);
          }
      };
      fetchMollieKeys();
  }, [user]);

  // Stringer Portal State
  const [selectedStringerPortal, setSelectedStringerPortal] = useState(null);

  // Racket History State
  const [customerPreviousRackets, setCustomerPreviousRackets] = useState([]);
  const [showRacketDropdown, setShowRacketDropdown] = useState(false);

  // Klanten Historie Mobiel Accordion State
  const [expandedHistoryJobId, setExpandedHistoryJobId] = useState(null);

  // Betaalverzoek Modal State
  const [paymentModalJob, setPaymentModalJob] = useState(null);
  const [paymentMessage, setPaymentMessage] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  // Testrackets State
  const [newTestracket, setNewTestracket] = useState({ brand: '', model: '', grip: '' });
  const [newRental, setNewRental] = useState({ testracketId: '', customerId: '', returnDate: '' });
  const [rentalCustomerSearch, setRentalCustomerSearch] = useState('');
  const [showRentalCustomerDropdown, setShowRentalCustomerDropdown] = useState(false);

  const [newJob, setNewJob] = useState({
    customerId: '', 
    racket: '', 
    stringId: 'custom', customString: '', 
    isHybrid: false,
    crossStringId: '', customCrossString: '',
    baseGripId: '', overGripId: '', 
    tensionMain: 24, tensionCross: 24, 
    tensionUnit: 'kg', 
    price: 15, notes: '', paid: false, 
    deadline: '', deadlineTime: '', 
    stringer: localStorage.getItem('lastStringer') || ''
  });

  const [newCustomer, setNewCustomer] = useState({ 
      name: '', club: '', phone: '', defaultRacketBrand: '', defaultRacketModel: '', defaultString: ''
  });

  const [processingInboxId, setProcessingInboxId] = useState(null); // Om de inbox aanvraag te onthouden

  // --- LOGICA ---
  
  const getRacketName = (job) => {
      if (job.racket) return job.racket;
      return `${job.racketBrand || ''} ${job.racketModel || ''}`.trim();
  };

  // Detecteer dubbele namen
  useEffect(() => {
    const groups = {};
    customers.forEach(c => {
      const name = c.name.trim().toLowerCase();
      if (!groups[name]) groups[name] = [];
      groups[name].push(c);
    });
    const duplicates = Object.values(groups).filter(g => g.length > 1);
    setDuplicateGroups(duplicates);
  }, [customers]);

  useEffect(() => {
    const groups = {};
    inventory.forEach(item => {
      const key = `${item.category || ''}-${item.brand || ''}-${item.model || ''}-${item.type || ''}-${item.gauge || ''}`.toLowerCase().replace(/\s+/g, '');
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    const duplicates = Object.values(groups).filter(g => g.length > 1);
    setDuplicateInventoryGroups(duplicates);
  }, [inventory]);

  // Effect voor het bouwen van de tekst van het betaalverzoek
  useEffect(() => {
      if (paymentModalJob) {
          const name = getCustomerName(paymentModalJob.customerId);
          const racket = getRacketName(paymentModalJob);
          const price = formatPrice(paymentModalJob.price);
          const link = paymentModalJob.paymentLink;
          const senderName = userProfile?.companyName || user?.displayName || 'Mijn Bespanservice';
          const msg = `Hoi ${name},\n\nJe racket (${racket}) is bespannen en ligt weer voor je klaar! 🎾\n\nDe kosten voor de bespanning zijn € ${price}. Je kunt het bedrag eenvoudig voldoen via de onderstaande betaallink:\n${link}\n\nAlvast bedankt en tot snel!\n\nGroeten,\n${senderName}`;
          setPaymentMessage(msg);
          setIsCopied(false);
      }
  }, [paymentModalJob, customers, userProfile, user]);

  // Instellen standaard datum voor testracket verhuur (+7 dagen)
  useEffect(() => {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      setNewRental(prev => ({ ...prev, returnDate: d.toISOString().split('T')[0] }));
  }, []);

  // --- NIEUWE FUNCTIE: Snel Klant Aanmaken ---
  const createQuickCustomer = async (name) => {
      if (!user || !name.trim()) return null;
      try {
          const newCustRef = await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'customers'), {
              name: name.trim(), 
              club: '', 
              phone: '', 
              defaultRacketBrand: '', 
              defaultRacketModel: '', 
              defaultString: '', 
              createdAt: Date.now()
          });
          return newCustRef.id;
      } catch (error) {
          console.error("Fout bij het direct aanmaken van klant:", error);
          alert("Kon nieuwe klant niet direct aanmaken.");
          return null;
      }
  };

  const handleCopyPaymentMessage = () => {
      const textArea = document.createElement("textarea");
      textArea.value = paymentMessage;
      document.body.appendChild(textArea);
      textArea.select();
      try {
          document.execCommand('copy');
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 2000);
      } catch (err) {
          console.error('Copy failed', err);
      }
      document.body.removeChild(textArea);
  };

  const getCustomerName = (id) => {
    const c = customers.find(c => c.id === id);
    return c ? c.name : 'Onbekend';
  };

  const getCategoryColor = (category) => {
      switch(category) {
          case 'Snaar': return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300';
          case 'Basisgrip': return 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300';
          case 'Overgrip': return 'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300';
          case 'Demper': return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300';
          default: return 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300';
      }
  };

  // --- BESPANNER & MOLLIE LOGICA ---
  const addStringer = async (e) => {
      e.preventDefault();
      if (!user || !newStringerName.trim()) return;
      try {
          await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'stringers'), { name: newStringerName.trim(), createdAt: Date.now() });
          setNewStringerName('');
      } catch (error) { console.error("Error adding stringer", error); }
  };

  const deleteStringer = async (id) => {
      if (!user) return;
      if (!confirm("Bespanner verwijderen?")) return;
      try { await deleteDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'stringers', id)); } 
      catch (error) { console.error(error); }
  };

const saveMollieKeys = async () => {
      if (!user) return;
      try {
          // Sla veilig op in een afgeschermd database document
          await setDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'private_settings', 'mollie'), {
              liveKey: mollieLiveKey,
              testKey: mollieTestKey,
              updatedAt: Date.now()
          }, { merge: true });
          
          // Bewaar ze ook lokaal voor snelle toegang
          localStorage.setItem('mollieLiveKey', mollieLiveKey);
          localStorage.setItem('mollieTestKey', mollieTestKey);
          alert("Mollie API sleutels veilig opgeslagen!");
      } catch (err) {
          console.error("Fout bij opslaan Mollie keys:", err);
          alert("Er ging iets mis bij het opslaan van de API sleutels.");
      }
  };

  const saveCompanyName = async () => {
      if (!user) return;
      try {
          await setDoc(doc(db, 'artifacts', appId, 'users', user.uid), {
              companyName: draftCompanyName.trim()
          }, { merge: true });
          alert("Bedrijfsinformatie succesvol opgeslagen!");
      } catch (err) {
          console.error(err);
          alert("Er is iets misgegaan bij het opslaan van je bedrijfsinformatie.");
      }
  };

  // --- NIEUW: Logo Upload Functie ---
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);

  const handleLogoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!e.target.files || e.target.files.length === 0 || !user) return;
      
      const file = e.target.files[0];
      
      // Check of het echt een plaatje is en niet te groot (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
          alert("Het bestand is te groot! Kies een afbeelding van maximaal 2MB.");
          return;
      }

      setIsUploadingLogo(true);
      try {
          // 1. Maak een mapje aan in Firebase Storage (bijv: logos/JouwUID/plaatje.png)
          const logoRef = ref(storage, `logos/${user.uid}/${file.name}`);
          
          // 2. Upload het bestand
          await uploadBytes(logoRef, file);
          
          // 3. Vraag de openbare link op naar dit plaatje
          const downloadURL = await getDownloadURL(logoRef);
          
          // 4. Sla deze link op in jouw gebruikersprofiel in de database
          await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid), {
              companyLogo: downloadURL
          });
          
      } catch (error) {
          console.error("Fout bij uploaden logo:", error);
          alert("Er is iets misgegaan bij het uploaden van je logo.");
      } finally {
          setIsUploadingLogo(false);
      }
  };

  const generateMollieLink = async (job) => {
const apiKey = localStorage.getItem('mollieLiveKey')?.trim() || localStorage.getItem('mollieApiKey')?.trim();      if (!apiKey) {
          alert("Stel eerst een Mollie API Key in via Instellingen.");
          return;
      }

      setGeneratingMollieId(job.id);
      
      try {
          const response = await fetch('/api/mollie', {
              method: 'POST',
              headers: {
                  'Authorization': `Bearer ${apiKey}`,
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                  amount: {
                      currency: 'EUR',
                      value: parseFloat(job.price).toFixed(2)
                  },
                  description: `Bespanning ${getCustomerName(job.customerId)} - ${getRacketName(job)}`,
                  redirectUrl: 'https://detenniswinkel.nl/pages/tnx',
                  webhookUrl: `${window.location.origin}/api/webhook?jobId=${job.id}&userId=${user?.uid}`
              })
          });

          const responseText = await response.text();
          let data;
          
          try {
              data = JSON.parse(responseText);
          } catch (e) {
              console.error("Geen geldige JSON ontvangen:", responseText);
              alert("De server stuurde geen geldige data terug.");
              setGeneratingMollieId(null);
              return;
          }
          
          if (response.ok && data._links && data._links.paymentLink) {
              const paymentUrl = data._links.paymentLink.href;
              await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', job.id), { paymentLink: paymentUrl });
              setPaymentModalJob({ ...job, paymentLink: paymentUrl });
          } else {
              console.error("Mollie Error:", data);
              const errorMsg = data.detail || data.title || data.error || data.message || JSON.stringify(data);
              alert("Fout bij aanmaken link: " + errorMsg);
          }
      } catch (error) {
          console.error("Error fetching Mollie link:", error);
          alert("Er kon geen netwerkverbinding worden gemaakt.");
      } finally {
          setGeneratingMollieId(null);
      }
  };

  // --- BEREKENING PRIJS HYBRIDE ---
  const calculateNewPrice = (updates) => {
      const current = { ...newJob, ...updates };
      let mainP = 0, crossP = 0, bgP = 0, ogP = 0;

      if (current.stringId === 'custom') mainP = 15;
      else if (current.stringId) {
          const item = inventory.find(i => i.id === current.stringId);
          if (item) mainP = item.price;
      }

      if (current.isHybrid) {
          if (current.crossStringId === 'custom') crossP = 15;
          else if (current.crossStringId) {
              const item = inventory.find(i => i.id === current.crossStringId);
              if (item) crossP = item.price;
          }
      }

      let finalStringPrice = mainP;
      if (current.isHybrid) {
          if (crossP > 0) {
              finalStringPrice = (mainP + crossP) / 2;
          } else {
              finalStringPrice = mainP;
          }
      }

      if (current.baseGripId) {
          const bg = inventory.find(i => i.id === current.baseGripId);
          if (bg) bgP = bg.price;
      }
      if (current.overGripId) {
          const og = inventory.find(i => i.id === current.overGripId);
          if (og) ogP = og.price;
      }

      return Math.max(0, finalStringPrice + bgP + ogP);
  };

  // --- TESTRACKET LOGICA ---
  const addTestracket = async (e) => {
      e.preventDefault();
      if (!user || !newTestracket.brand || !newTestracket.model) return;
      try {
          await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'testrackets'), {
              ...newTestracket, status: 'available', createdAt: Date.now()
          });
          setNewTestracket({ brand: '', model: '', grip: '' });
      } catch (err) { console.error(err); alert("Kon testracket niet opslaan"); }
  };

  const deleteTestracket = async (id) => {
      if (!user) return;
      if (!confirm("Weet je zeker dat je dit testracket wilt verwijderen?")) return;
      try {
          await deleteDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'testrackets', id));
      } catch (err) { console.error(err); }
  };

  const selectCustomerForRental = (customer) => {
      setNewRental({ ...newRental, customerId: customer.id });
      setRentalCustomerSearch(customer.name);
      setShowRentalCustomerDropdown(false);
  };

  const rentTestracket = async (e) => {
      e.preventDefault();
      if (!user || !newRental.testracketId || !newRental.customerId || !newRental.returnDate) {
          alert("Vul alle velden in om een testracket uit te lenen.");
          return;
      }
      try {
          const startDate = new Date().toISOString().split('T')[0];
          await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'testrackets', newRental.testracketId), {
              status: 'rented',
              currentRental: {
                  customerId: newRental.customerId,
                  startDate: startDate,
                  returnDate: newRental.returnDate
              }
          });

          const customer = customers.find(c => c.id === newRental.customerId);
          const racket = testrackets.find(r => r.id === newRental.testracketId);
          if (customer && racket) {
              const currentHistory = customer.testHistory || [];
              await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'customers', customer.id), {
                  testHistory: [{
                      id: Date.now(),
                      racketId: racket.id,
                      brand: racket.brand,
                      model: racket.model,
                      startDate: startDate,
                      returnDate: newRental.returnDate
                  }, ...currentHistory]
              });
          }

          const d = new Date();
          d.setDate(d.getDate() + 7);
          setNewRental({ testracketId: '', customerId: '', returnDate: d.toISOString().split('T')[0] });
          setRentalCustomerSearch('');
      } catch (err) { console.error(err); alert("Kon verhuur niet opslaan"); }
  };

  const returnTestracket = async (id) => {
      if (!user) return;
      if (!confirm("Is dit racket succesvol teruggebracht?")) return;
      try {
          await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'testrackets', id), {
              status: 'available',
              currentRental: null
          });
      } catch (err) { console.error(err); }
  };

  // --- PRINT LOGICA ---
  const openPrintModal = (jobsInput) => {
      const jobsArray = Array.isArray(jobsInput) ? jobsInput : [jobsInput];
      setJobsToPrint(jobsArray);
      setShowPrintModal(true);
  };

const handlePrint = () => {
      if (jobsToPrint.length === 0) return;
      window.print();
  };
  
  const handleBulkPrintJobs = () => {
      const jobsSelected = jobs.filter(j => selectedJobIds.has(j.id));
      if (jobsSelected.length > 0) {
          openPrintModal(jobsSelected);
      }
  };

  // --- BULK ACTIES, FILTER & MERGE ---
  
  // INVENTORY BULK & MERGE
  const toggleInventorySelection = (id) => {
      const newSet = new Set(selectedInventoryIds);
      if (newSet.has(id)) newSet.delete(id); else newSet.add(id);
      setSelectedInventoryIds(newSet);
  };

  const handleSelectAllInventory = (filteredItems) => {
      if (filteredItems.length > 0 && filteredItems.every(item => selectedInventoryIds.has(item.id))) {
           const newSet = new Set(selectedInventoryIds);
           filteredItems.forEach(item => newSet.delete(item.id));
           setSelectedInventoryIds(newSet);
      } else {
           const newSet = new Set(selectedInventoryIds);
           filteredItems.forEach(item => newSet.add(item.id));
           setSelectedInventoryIds(newSet);
      }
  };

  const handleBulkDeleteInventory = async () => {
      if (!user || selectedInventoryIds.size === 0) return;
      if (!window.confirm(`Weet je ZEKER dat je ${selectedInventoryIds.size} materialen wilt verwijderen?`)) return;
      const batch = writeBatch(db);
      selectedInventoryIds.forEach((id) => {
          const ref = doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', id);
          batch.delete(ref);
      });
      try { await batch.commit(); setSelectedInventoryIds(new Set()); } catch (error) { console.error(error); alert("Fout bij verwijderen."); }
  };

  const mergeInventoryGroup = async (group) => {
      if (!user) return;
      const totalStock = group.reduce((acc, item) => acc + (parseInt(item.stock) || 0), 0);
      const targetItem = group[0]; 
      const itemsToDelete = group.slice(1);

      if(!window.confirm(`Gevonden: ${group.length}x "${targetItem.brand} ${targetItem.model}".\nWil je deze samenvoegen tot 1 item met totale voorraad ${totalStock}?`)) return;

      const batch = writeBatch(db);
      const targetRef = doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', targetItem.id);
      batch.update(targetRef, { stock: totalStock });

      itemsToDelete.forEach(item => {
          const ref = doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', item.id);
          batch.delete(ref);
      });

      try {
          await batch.commit();
      } catch (e) {
          console.error("Merge error", e);
          alert("Kon niet samenvoegen.");
      }
  };

  const mergeAllInventoryGroups = async () => {
    if (!user || duplicateInventoryGroups.length === 0) return;
    if (!window.confirm(`Wil je alle ${duplicateInventoryGroups.length} groepen dubbele materialen automatisch samenvoegen?`)) return;
    
    setIsProcessingImport(true);
    let currentBatch = writeBatch(db);
    let currentCount = 0;
    const batchSize = 400; 
    let actions = [];

    duplicateInventoryGroups.forEach(group => {
        const totalStock = group.reduce((acc, item) => acc + (parseInt(item.stock) || 0), 0);
        const targetItem = group[0];
        const itemsToDelete = group.slice(1);

        actions.push({ type: 'update', ref: doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', targetItem.id), data: { stock: totalStock } });
        itemsToDelete.forEach(item => {
            actions.push({ type: 'delete', ref: doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', item.id) });
        });
    });

    try {
        for (const action of actions) {
            if (action.type === 'update') { currentBatch.update(action.ref, action.data); } 
            else { currentBatch.delete(action.ref); }
            currentCount++;
            if (currentCount >= batchSize) {
                await currentBatch.commit();
                currentBatch = writeBatch(db);
                currentCount = 0;
            }
        }
        if (currentCount > 0) await currentBatch.commit();

        setDuplicateInventoryGroups([]); 
        alert("Alle materialen zijn samengevoegd!");
    } catch (e) {
        console.error("Bulk merge failed", e);
        alert("Er ging iets mis met samenvoegen.");
    } finally {
        setIsProcessingImport(false);
    }
  };
  
  const handleInventoryExport = () => {
    if (inventory.length === 0) {
      alert("Geen voorraad om te exporteren.");
      return;
    }

    try {
      const headers = ["Categorie", "Merk", "Model", "Type", "Gauge", "Voorraad", "Prijs"];
      const rows = inventory.map(item => [
        item.category || "", item.brand || "", item.model || "", item.type || "", item.gauge || "", item.stock || 0, item.price || 0
      ]);

      const csvContent = [
        headers.join(","),
        ...rows.map(row => row.map(value => `"${value}"`).join(","))
      ].join("\n");

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `voorraad_export_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Export fout:", error);
      alert("Er ging iets mis bij het exporteren van de voorraad.");
    }
  };

  // CUSTOMER BULK & MERGE
  const toggleCustomerSelection = (id) => {
      const newSet = new Set(selectedCustomerIds);
      if (newSet.has(id)) newSet.delete(id); else newSet.add(id);
      setSelectedCustomerIds(newSet);
  };

  const handleBulkDeleteCustomers = async () => {
      if (!user || selectedCustomerIds.size === 0) return;
      if (!window.confirm(`Weet je ZEKER dat je ${selectedCustomerIds.size} klanten wilt verwijderen? Dit kan niet ongedaan gemaakt worden.`)) return;
      const batch = writeBatch(db);
      selectedCustomerIds.forEach((id) => {
          const ref = doc(db, 'artifacts', appId, 'users', user.uid, 'customers', id);
          batch.delete(ref);
      });
      try { await batch.commit(); setSelectedCustomerIds(new Set()); } catch (error) { console.error(error); alert("Fout bij verwijderen."); }
  };

  const handleMergeClubs = async (primaryClub, secondaryClubs) => {
      if (!user || secondaryClubs.length === 0) return;
      
      if (!window.confirm(`Weet je zeker dat je ${secondaryClubs.length} foute clubnaam/namen wilt wijzigen naar: "${primaryClub}"?`)) return;

      try {
          setIsProcessingImport(true); 
          const batch = writeBatch(db);
          let updateCount = 0;

          // Loop door al je klanten heen en zoek degene met een foute clubnaam
          customers.forEach(customer => {
              if (secondaryClubs.includes(customer.club)) {
                  const customerRef = doc(db, 'artifacts', appId, 'users', user.uid, 'customers', customer.id);
                  batch.update(customerRef, { club: primaryClub });
                  updateCount++;
              }
          });

          // Voer de opslag direct in Firebase uit
          if (updateCount > 0) {
              await batch.commit();
              alert(`Succesvol samengevoegd! ${updateCount} klant(en) zijn geüpdatet naar "${primaryClub}".`);
          } else {
              alert("Er waren geen klanten gevonden met de geselecteerde te verwijderen clubnamen.");
          }
          
      } catch (error) {
          console.error("Fout bij het updaten van de clubnamen:", error);
          alert("Er ging iets mis met het opslaan in de database.");
      } finally {
          setIsProcessingImport(false);
      }
  };
const handleConfirmMerge = async (primaryId, secondaryIds) => {
    if (!user || secondaryIds.length === 0) return;
    setIsProcessingImport(true);

    try {
        const batch = writeBatch(db);

        // 1. Zoek alle bespanningen (jobs) van de dubbele klanten die weggaan
        const jobsToMove = jobs.filter(job => secondaryIds.indexOf(job.customerId) !== -1);
        
        // 2. Koppel al die bespanningen aan het nieuwe, overblijvende hoofdprofiel
        jobsToMove.forEach(job => {
            const jobRef = doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', job.id);
            batch.update(jobRef, { customerId: primaryId });
        });

        // 3. Verwijder de dubbele klantprofielen uit de database
        secondaryIds.forEach(custId => {
            const custRef = doc(db, 'artifacts', appId, 'users', user.uid, 'customers', custId);
            batch.delete(custRef);
        });

        // 4. Voer alle wijzigingen in één keer uit (opslaan!)
        await batch.commit();

        // 5. Maak de vinkjes op het scherm weer leeg en update de waarschuwingen
        setSelectedCustomerIds(new Set());
        setDuplicateGroups(prev => prev.filter(g => !g.some(c => secondaryIds.indexOf(c.id) !== -1)));
        
        alert(`Succesvol samengevoegd! ${jobsToMove.length} bespanning(en) verplaatst naar het hoofdprofiel.`);
    } catch (error) {
        console.error("Merge failed:", error);
        alert("Er ging iets mis met opslaan in de database.");
    } finally {
        setIsProcessingImport(false);
    }
};
  const startEditingCustomer = () => { setEditingCustomerData({ ...selectedCustomerForHistory }); setIsEditingCustomer(true); };
  const saveEditedCustomer = async () => {
      if (!user || !editingCustomerData) return;
      try {
          await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'customers', editingCustomerData.id), editingCustomerData);
          setSelectedCustomerForHistory(editingCustomerData); setIsEditingCustomer(false);
      } catch (error) { console.error(error); alert("Fout bij opslaan."); }
  };

  const toggleJobSelection = (id) => {
      const newSet = new Set(selectedJobIds);
      if (newSet.has(id)) newSet.delete(id); else newSet.add(id);
      setSelectedJobIds(newSet);
  };

  const handleSelectAllJobs = (filteredJobs) => {
      if (selectedJobIds.size === filteredJobs.length && filteredJobs.length > 0) { setSelectedJobIds(new Set()); } 
      else { const newSet = new Set(); filteredJobs.forEach(job => newSet.add(job.id)); setSelectedJobIds(newSet); }
  };

const handleBulkDeleteJobs = async () => {
    if (!user || selectedJobIds.size === 0) return;
    if (!window.confirm(`Weet je ZEKER dat je ${selectedJobIds.size} geselecteerde opdracht(en) wilt verwijderen?`)) return;
    const batch = writeBatch(db);
    selectedJobIds.forEach((id) => { 
        const ref = doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', id); 
        batch.delete(ref); 
    });
    try { 
        await batch.commit(); 
        setSelectedJobIds(new Set()); 
    } catch (error) { 
        console.error(error); 
    }
};
  const openJobEditModal = (job) => { 
      setEditingJob({ 
          ...job,
          racket: getRacketName(job),
          deadlineTime: job.deadlineTime || '',
          isHybrid: job.isHybrid || false,
          crossString: job.crossString || '',
          stringer: job.stringer || ''
      }); 
  };
  
  const saveEditedJob = async (e) => { 
      e.preventDefault(); 
      if (!user || !editingJob) return; 
      try { 
          await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', editingJob.id), { 
              ...editingJob, 
              price: parseFloat(editingJob.price), 
              tensionMain: parseFloat(editingJob.tensionMain), 
              tensionCross: parseFloat(editingJob.tensionCross) 
          }); 
          setEditingJob(null); 
      } catch (error) { console.error(error); alert("Fout bij opslaan"); } 
  };
  const cycleStatus = async (job) => { if (!user) return; const statuses = ['Nieuw', 'Bezig', 'Klaar']; const nextStatus = statuses[(statuses.indexOf(job.status || 'Nieuw') + 1) % statuses.length]; try { await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', job.id), { status: nextStatus, completedAt: nextStatus === 'Klaar' ? Date.now() : (job.completedAt || null) }); } catch (err) { console.error(err); } };
  const togglePaid = async (job) => { if (!user) return; try { await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', job.id), { paid: !job.paid, completedAt: !job.paid ? Date.now() : (job.completedAt || null) }); } catch (err) { console.error(err); } };
  
  const toggleStringerPaid = async (job) => {
      if (!user) return;
      try {
          await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', job.id), { stringerPaid: !job.stringerPaid });
      } catch (err) { console.error(err); }
  };

  const handleBulkPayStringer = async (openJobsForStringer) => {
      if (!user || openJobsForStringer.length === 0) return;
      if (!window.confirm(`Weet je zeker dat je ${openJobsForStringer.length} rackets als uitbetaald wilt markeren?`)) return;
      const batch = writeBatch(db);
      openJobsForStringer.forEach(job => {
          const ref = doc(db, 'artifacts', appId, 'users', user.uid, 'jobs', job.id);
          batch.update(ref, { stringerPaid: true });
      });
      try { await batch.commit(); } catch (e) { console.error(e); }
  };

  const findLastTensionForRacket = (customerId, racketName) => {
      if (!customerId || !racketName) return null;
      const previousJobs = jobs
          .filter(j => j.customerId === customerId && getRacketName(j) === racketName)
          .sort((a, b) => new Date(b.date) - new Date(a.date)); 

      if (previousJobs.length > 0) {
          const lastJob = previousJobs[0];
          return { tensionMain: lastJob.tensionMain, tensionCross: lastJob.tensionCross, tensionUnit: lastJob.tensionUnit || 'kg' };
      }
      return null;
  };

  const selectCustomerForJob = (customer) => { 
      const customerJobs = jobs.filter(j => j.customerId === customer.id);
      const uniqueRackets = [...new Set(customerJobs.map(j => getRacketName(j)).filter(Boolean))];
      setCustomerPreviousRackets(uniqueRackets);

      if (processingInboxId) {
          // Bij het verwerken van een inbox-aanvraag behouden we de ingevulde racket/snaar/kilo's
          setNewJob(prev => ({ 
              ...prev, 
              customerId: customer.id 
          }));
      } else {
          // Normaal gedrag: vul klant-defaults in
          const defaultRacket = `${customer.defaultRacketBrand || ''} ${customer.defaultRacketModel || ''}`.trim();
          
          let lastTensionData = {};
          if (defaultRacket) {
              const found = findLastTensionForRacket(customer.id, defaultRacket);
              if (found) lastTensionData = found;
          }

          setNewJob(prev => ({ 
              ...prev, 
              customerId: customer.id, 
              racket: defaultRacket, 
              customString: customer.defaultString || '',
              ...lastTensionData 
          })); 
      }
      
      setCustomerSearchTerm(customer.name); 
      setShowCustomerDropdown(false); 
  };

  // --- NIEUW: Direct een inbox item verwerken (het Groene Vinkje) ---
  const handleDirectProcessItem = async (item: any) => {
      if (!user) return;

      try {
          // 1. Zoek of de klant al bestaat (op basis van telefoon of naam)
          let targetCustomerId = '';
          const existingCustomer = customers.find(c => c.phone === item.phone || c.name.toLowerCase() === item.name.toLowerCase());

          if (existingCustomer) {
              targetCustomerId = existingCustomer.id;
          } else {
              // Maak direct een nieuwe klant aan als hij nog niet in je systeem staat
              const newCustomerRef = await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'customers'), {
                  name: item.name || '',
                  phone: item.phone || '',
                  address: item.address || '',
                  club: item.club || '',
                  createdAt: new Date().toISOString()
              });
              targetCustomerId = newCustomerRef.id;
          }

          // 2. Maak de opdracht (job) direct aan zonder het new-job scherm te openen
          await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'jobs'), {
              customerId: targetCustomerId,
              racket: item.racket || '',
              stringId: 'custom', 
              customString: item.string || '',
              isHybrid: item.isHybrid || false,
              crossStringId: item.isHybrid ? 'custom' : '',
              customCrossString: item.crossString || '',
              tensionMain: item.tensionMain || 24,
              tensionCross: item.tensionCross || 24,
              tensionUnit: 'kg',
              price: 0, 
              notes: `Binnengekomen via formulier.${item.ownString ? '\nLET OP: Klant levert eigen snaar aan!' : ''}`,
              date: new Date().toISOString(),
              deadline: item.deadline || '',
              deadlineTime: item.deadlineTime || '',
              status: 'In de wacht',
              stringer: localStorage.getItem('lastStringer') || '',
              paid: false
          });

          // 3. Verwijder hem uit de inbox-wachtrij omdat hij nu succesvol is verwerkt
          await deleteDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inbox', item.id));

      } catch (error) {
          console.error("Fout bij direct opslaan:", error);
          alert("Er ging iets mis bij het direct verwerken van de aanvraag.");
      }
  };
  
  const duplicateJob = (job) => {
      const customer = customers.find(c => c.id === job.customerId);
      if (customer) {
          setCustomerSearchTerm(customer.name);
          const customerJobs = jobs.filter(j => j.customerId === customer.id);
          const uniqueRackets = [...new Set(customerJobs.map(j => getRacketName(j)).filter(Boolean))];
          setCustomerPreviousRackets(uniqueRackets);
      }

      let sId = job.stringId || 'custom';
      let cString = job.customString || '';
      if (!job.stringId && job.string) {
          sId = 'custom';
          cString = job.string;
      }

      setNewJob({
          customerId: job.customerId,
          racket: getRacketName(job),
          stringId: sId,
          customString: cString,
          isHybrid: job.isHybrid || false,
          crossStringId: job.crossStringId || '',
          customCrossString: job.customCrossString || '',
          baseGripId: job.baseGripId || '',
          overGripId: job.overGripId || '',
          tensionMain: job.tensionMain || 24,
          tensionCross: job.tensionCross || 24,
          tensionUnit: job.tensionUnit || 'kg',
          price: job.price || 0,
          notes: job.notes || '',
          stringer: job.stringer || localStorage.getItem('lastStringer') || '',
          deadline: '', 
          deadlineTime: '',
          paid: false
      });

      if (sId !== 'custom') {
          const item = inventory.find(i => i.id === sId);
          if (item) setStringSearchTerm(`${item.brand} ${item.model}`);
      } else {
          setStringSearchTerm(cString);
      }
      
      if (job.isHybrid) {
          if (job.crossStringId && job.crossStringId !== 'custom') {
              const item = inventory.find(i => i.id === job.crossStringId);
              if (item) setCrossStringSearchTerm(`${item.brand} ${item.model}`);
          } else {
              setCrossStringSearchTerm(job.customCrossString || '');
          }
      }

      setActiveTab('new-job');
  };

  const openCustomerHistory = (customer) => { 
      setSelectedCustomerForHistory(customer); 
      setSearchQuery(''); 
      setShowGlobalSearchDropdown(false); 
      setIsEditingCustomer(false); 
      setExpandedHistoryJobId(null);
      setActiveTab('customer-history'); 
  };
  
  const addJob = async (e) => { 
      e.preventDefault(); 
      if (!user || !newJob.customerId || !newJob.racket) return; 
      
      if (newJob.stringer) {
          localStorage.setItem('lastStringer', newJob.stringer);
      }

      let stringName = newJob.customString; 
      let selectedStringItem = null;

      if (newJob.stringId !== 'custom' && newJob.stringId) {
          selectedStringItem = inventory.find(s => s.id === newJob.stringId);
          if (selectedStringItem) stringName = `${selectedStringItem.brand} ${selectedStringItem.model}`;
      }
      
      let crossName = '';
      if (newJob.isHybrid) {
          crossName = newJob.customCrossString;
          let selectedCrossItem = null;
          
          if (newJob.crossStringId && newJob.crossStringId !== 'custom') {
              selectedCrossItem = inventory.find(s => s.id === newJob.crossStringId);
              if (selectedCrossItem) crossName = `${selectedCrossItem.brand} ${selectedCrossItem.model}`;
          }
          
          if (crossName) {
              stringName = `Hybrid: ${stringName || 'Onbekend'} / ${crossName}`;
          }
      }

      let selectedBaseGripItem = inventory.find(g => g.id === newJob.baseGripId); 
      let selectedOverGripItem = inventory.find(g => g.id === newJob.overGripId); 

      const jobData = { 
          date: new Date().toISOString().split('T')[0], 
          status: 'Nieuw', 
          paid: false, 
          ...newJob, 
          string: stringName, 
          crossString: crossName,
          baseGrip: selectedBaseGripItem ? `${selectedBaseGripItem.brand} ${selectedBaseGripItem.model}` : '', 
          overGrip: selectedOverGripItem ? `${selectedOverGripItem.brand} ${selectedOverGripItem.model}` : '', 
          price: parseFloat(newJob.price), 
          createdAt: Date.now(), 
          completedAt: null, 
          deadline: newJob.deadline,
          deadlineTime: newJob.deadlineTime
      }; 
      try { 
          await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'jobs'), jobData); 
          if (selectedStringItem?.stock > 0) await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', selectedStringItem.id), { stock: selectedStringItem.stock - 1 });
          
          if (newJob.isHybrid && newJob.crossStringId && newJob.crossStringId !== 'custom') {
               const crossItem = inventory.find(s => s.id === newJob.crossStringId);
               if (crossItem && crossItem.stock > 0) {
                   await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', crossItem.id), { stock: crossItem.stock - 1 }); 
               }
          }

          if (selectedBaseGripItem?.stock > 0) await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', selectedBaseGripItem.id), { stock: selectedBaseGripItem.stock - 1 }); 
          if (selectedOverGripItem?.stock > 0) await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', selectedOverGripItem.id), { stock: selectedOverGripItem.stock - 1 }); 
          
          // Verwijder uit inbox (privé pad) indien dit via een aanvraag liep
          if (processingInboxId) {
              await deleteDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inbox', processingInboxId));
              setProcessingInboxId(null);
          }
          
          setActiveTab('dashboard'); 
          
          setNewJob({ 
              ...newJob, 
              racket: '', 
              notes: '', stringId: 'custom', customString: '', baseGripId: '', overGripId: '', paid: false, price: 15, deadline: '', deadlineTime: '', isHybrid: false, crossStringId: '', customCrossString: '', 
              stringer: localStorage.getItem('lastStringer') || '' 
          }); 
          setCustomerSearchTerm(''); 
          setStringSearchTerm(''); 
          setCrossStringSearchTerm('');
          setCustomerPreviousRackets([]);
      } catch (error) { console.error(error); alert("Kon opdracht niet opslaan."); } 
  };
  
  const addCustomer = async (e) => { e.preventDefault(); if (!user || !newCustomer.name) return; try { await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'customers'), { ...newCustomer, createdAt: Date.now() }); setNewCustomer({ name: '', club: '', phone: '', defaultRacketBrand: '', defaultRacketModel: '', defaultString: '' }); } catch (error) { console.error("Fout bij opslaan klant:", error); } };
  
  // --- IMPORTS ---
  const handleInventoryImport = async () => {
      if (!user || !importText.trim()) return;
      setIsProcessingImport(true);
      const rows = importText.split('\n');
      const batchSize = 400; 
      let batch = writeBatch(db);
      let count = 0;
      let batchCount = 0;

      for (const row of rows) {
          if (!row.trim()) continue;
          const cols = row.split('\t'); 
          if (cols.length >= 2) {
              const item = { brand: cols[0]?.trim(), model: cols[1]?.trim(), type: cols[2]?.trim(), gauge: cols[3]?.trim(), price: parseDutchPrice(cols[4]), stock: parseInt(cols[5]) || 0, category: cols[6]?.trim() || 'Snaar', createdAt: Date.now() };
              
              const ref = doc(collection(db, 'artifacts', appId, 'users', user.uid, 'inventory'));
              batch.set(ref, item);
              count++;
              batchCount++;
              
              if(batchCount >= batchSize) {
                  await batch.commit();
                  batch = writeBatch(db);
                  batchCount = 0;
              }
          }
      }
      if(batchCount > 0) await batch.commit();
      
      setIsProcessingImport(false); 
      alert(`${count} materialen geïmporteerd!`); 
      setImportText(''); 
      setShowImportModal(false);
  };
  
  const handleCustomerImport = async () => {
      if (!user || !importText.trim()) return;
      setIsProcessingImport(true);
      const rows = importText.split('\n');
      const batchSize = 400;
      let batch = writeBatch(db);
      let count = 0;
      let batchCount = 0;

      for (const row of rows) {
          if (!row.trim()) continue;
          const cols = row.split('\t'); 
          if (cols.length >= 1 && cols[0].trim()) {
              const customer = { name: cols[0].trim(), club: cols[1]?.trim() || '', phone: cols[2]?.trim() || '', defaultRacketBrand: cols[3]?.trim() || '', defaultRacketModel: cols[4]?.trim() || '', defaultString: cols[5]?.trim() || '', createdAt: Date.now() };
              const ref = doc(collection(db, 'artifacts', appId, 'users', user.uid, 'customers'));
              batch.set(ref, customer);
              count++;
              batchCount++;

              if(batchCount >= batchSize) {
                  await batch.commit();
                  batch = writeBatch(db);
                  batchCount = 0;
              }
          }
      }
      if(batchCount > 0) await batch.commit();

      setIsProcessingImport(false); 
      alert(`${count} klanten geïmporteerd!`); 
      setImportText(''); 
      setShowCustomerImportModal(false);
  };

  const handleJobImport = async () => { 
      if (!user || !importText.trim()) return; 
      setIsProcessingImport(true); 
      const rows = importText.split('\n'); 
      let count = 0; 
      
      const customerMap = new Map();
      customers.forEach(c => customerMap.set(c.name.toLowerCase(), c.id));
      
      for (const row of rows) { 
          if (!row.trim()) continue; 
          const cols = row.split('\t'); 
          if (cols.length >= 2) { 
              try { 
                  const customerName = cols[1]?.trim() || 'Onbekend'; 
                  const lowerName = customerName.toLowerCase();
                  let customerId = ''; 
                  
                  if (customerMap.has(lowerName)) {
                      customerId = customerMap.get(lowerName);
                  } else { 
                      const newCustRef = await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'customers'), { name: customerName, club: '', phone: '', createdAt: Date.now() }); 
                      customerId = newCustRef.id; 
                      customerMap.set(lowerName, customerId);
                  } 
                  
                  const job = { date: cols[0]?.trim(), customerId: customerId, racketBrand: cols[2]?.trim(), racketModel: cols[3]?.trim(), string: cols[4]?.trim(), tensionMain: cols[5]?.trim(), tensionCross: cols[6]?.trim(), price: parseDutchPrice(cols[7]), status: cols[8]?.trim() || 'Klaar', paid: true, createdAt: Date.now(), completedAt: Date.now() }; 
                  await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'jobs'), job); 
                  count++; 
              } catch (err) { console.error(err); } 
          } 
      } 
      setIsProcessingImport(false); 
      alert(`${count} opdrachten geïmporteerd!`); 
      setImportText(''); 
      setShowJobImportModal(false); 
  };

  // --- STRING ZOEK & PRIJS LOGICA ---
  const selectStringForJob = (item) => {
      const updates = { stringId: item.id, customString: '' };
      setNewJob(prev => ({ ...prev, ...updates, price: calculateNewPrice(updates) }));
      setStringSearchTerm(`${item.brand} ${item.model}`);
      setShowStringDropdown(false);
  };

  const handleManualStringInput = (e) => {
      const val = e.target.value;
      setStringSearchTerm(val);
      setShowStringDropdown(true);
      const updates = { stringId: 'custom', customString: val };
      setNewJob(prev => ({ ...prev, ...updates, price: calculateNewPrice(updates) }));
  };

  const selectCrossStringForJob = (item) => {
      const updates = { crossStringId: item.id, customCrossString: '' };
      setNewJob(prev => ({ ...prev, ...updates, price: calculateNewPrice(updates) }));
      setCrossStringSearchTerm(`${item.brand} ${item.model}`);
      setShowCrossStringDropdown(false);
  };

  const handleManualCrossStringInput = (e) => {
      const val = e.target.value;
      setCrossStringSearchTerm(val);
      setShowCrossStringDropdown(true);
      const updates = { crossStringId: 'custom', customCrossString: val };
      setNewJob(prev => ({ ...prev, ...updates, price: calculateNewPrice(updates) }));
  };

  const toggleHybridMode = (e) => {
      const isHybrid = e.target.checked;
      const updates = { isHybrid };
      setNewJob(prev => ({ ...prev, ...updates, price: calculateNewPrice(updates) }));
  };

  const handleBaseGripChange = (e) => { 
      const updates = { baseGripId: e.target.value };
      setNewJob(prev => ({ ...prev, ...updates, price: calculateNewPrice(updates) }));
  };
  
  const handleOverGripChange = (e) => { 
      const updates = { overGripId: e.target.value };
      setNewJob(prev => ({ ...prev, ...updates, price: calculateNewPrice(updates) }));
  };
  
  const openItemModal = (item = null) => { if (item) { setEditingItem({ ...item }); } else { setEditingItem({ category: 'Snaar', brand: '', model: '', type: '', gauge: '', price: '', stock: '' }); } };
  const saveItem = async (e) => { e.preventDefault(); if (!user || !editingItem) return; try { const itemData = { ...editingItem, price: parseFloat(editingItem.price)||0, stock: parseInt(editingItem.stock)||0 }; if (editingItem.id) { const {id, ...data} = itemData; await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', editingItem.id), data); } else { await addDoc(collection(db, 'artifacts', appId, 'users', user.uid, 'inventory'), { ...itemData, createdAt: Date.now() }); } setEditingItem(null); } catch (error) { console.error(error); } };
  const deleteItem = async (id) => { if (!user || !window.confirm("Zeker weten?")) return; try { await deleteDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inventory', id)); setEditingItem(null); } catch (error) { console.error(error); } };

  const saveCustomLinkId = async () => {
      if (!user || !draftLinkId.trim()) return;
      try {
          await setDoc(doc(db, 'artifacts', appId, 'users', user.uid), {
              customLinkId: draftLinkId.trim().toLowerCase().replace(/[^a-z0-9_-]/g, '')
          }, { merge: true });
          alert("Link-ID succesvol opgeslagen!");
      } catch (err) {
          console.error(err);
          alert("Er is iets misgegaan bij het opslaan van je Link-ID.");
      }
  };

  const requestDashboardSort = (key) => {
      let direction = 'ascending';
      if (dashboardSortConfig.key === key && dashboardSortConfig.direction === 'ascending') {
          direction = 'descending';
      }
      setDashboardSortConfig({ key, direction });
  };

  const requestArchiveSort = (key) => {
      let direction = 'ascending';
      if (archiveSortConfig.key === key && archiveSortConfig.direction === 'ascending') {
          direction = 'descending';
      }
      setArchiveSortConfig({ key, direction });
  };

  const requestInventorySort = (key) => {
    let direction = 'ascending';
    if (inventorySortConfig && inventorySortConfig.key === key && inventorySortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setInventorySortConfig({ key, direction });
  };

  const requestTestracketsSort = (key) => {
      let direction = 'ascending';
      if (testracketsSortConfig.key === key && testracketsSortConfig.direction === 'ascending') {
          direction = 'descending';
      }
      setTestracketsSortConfig({ key, direction });
  };

  const requestCustomerHistorySort = (key) => {
      let direction = 'ascending';
      if (customerHistorySortConfig.key === key && customerHistorySortConfig.direction === 'ascending') {
          direction = 'descending';
      }
      setCustomerHistorySortConfig({ key, direction });
  };

  const requestStringerSort = (key) => {
      let direction = 'ascending';
      if (stringerSortConfig.key === key && stringerSortConfig.direction === 'ascending') {
          direction = 'descending';
      }
      setStringerSortConfig({ key, direction });
  };

  const processInboxItem = async (item) => {
      const existingCustomer = customers.find(c => c.name.toLowerCase() === item.name.toLowerCase());
      let custId = '';
      let searchTerm = item.name;

      if (existingCustomer) {
          custId = existingCustomer.id;
      } else {
          const newCustId = await createQuickCustomer(item.name);
          if (newCustId) {
              custId = newCustId;
              if (item.phone) {
                  await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'customers', newCustId), { phone: item.phone });
              }
          }
      }

      setProcessingInboxId(item.id);
      
      let tMain = item.tensionMain ? parseFloat(item.tensionMain) : 24;
      let tCross = item.tensionCross ? parseFloat(item.tensionCross) : tMain;

      if (item.tension && !item.tensionMain) {
          const parts = item.tension.replace(/kg/gi, '').replace(/lbs/gi, '').split('/');
          if (parts.length > 0 && !isNaN(parseFloat(parts[0]))) tMain = parseFloat(parts[0]);
          if (parts.length > 1 && !isNaN(parseFloat(parts[1]))) tCross = parseFloat(parts[1]);
          else tCross = tMain;
      }

      const ownStringPrefix = item.ownString ? '(Eigen snaar) ' : '';

      setNewJob({
          ...newJob,
          customerId: custId,
          racket: item.racket || '',
          stringId: 'custom',
          customString: item.string ? `${ownStringPrefix}${item.string}` : (item.ownString ? 'Eigen snaar' : ''),
          isHybrid: item.isHybrid || false,
          crossStringId: 'custom',
          customCrossString: item.crossString || '',
          tensionMain: tMain,
          tensionCross: tCross,
          deadline: item.deadline || '',
          deadlineTime: item.deadlineTime || ''
      });

      setCustomerSearchTerm(searchTerm);
      setStringSearchTerm(item.string || '');
      setActiveTab('new-job');
  };

  // --- HIER STAAT DE VERNIEUWDE FUNCTIE: NU MET SNAAR ZOEKBALK SYNC ---
  const handleRepeatJob = (pastJob) => {
      if (selectedCustomerForHistory) {
          setCustomerSearchTerm(selectedCustomerForHistory.name);
      }

      // Bepaal de juiste string search term
      const sId = pastJob.stringId || 'custom';
      const cString = (sId === 'custom') ? (pastJob.string || pastJob.customString || '') : '';

      if (sId !== 'custom') {
          const item = inventory.find(i => i.id === sId);
          if (item) {
              setStringSearchTerm(`${item.brand} ${item.model}`);
          } else {
              setStringSearchTerm(pastJob.string || ''); // Fallback als item is verwijderd
          }
      } else {
          setStringSearchTerm(cString);
      }

      // Bepaal de juiste cross string search term (indien hybride)
      const isHybrid = pastJob.isHybrid || false;
      const csId = pastJob.crossStringId || 'custom';
      const cCrossString = (csId === 'custom') ? (pastJob.crossString || pastJob.customCrossString || '') : '';

      if (isHybrid) {
          if (csId !== 'custom') {
              const item = inventory.find(i => i.id === csId);
              if (item) {
                  setCrossStringSearchTerm(`${item.brand} ${item.model}`);
              } else {
                  setCrossStringSearchTerm(pastJob.crossString || ''); // Fallback
              }
          } else {
              setCrossStringSearchTerm(cCrossString);
          }
      } else {
          setCrossStringSearchTerm('');
      }

      setNewJob({
          ...newJob,
          customerId: pastJob.customerId,
          racket: pastJob.racket || '',
          
          stringId: sId,
          customString: cString,
          
          isHybrid: isHybrid,
          crossStringId: csId,
          customCrossString: cCrossString,
          
          tensionMain: pastJob.tensionMain || 24,
          tensionCross: pastJob.tensionCross || 24,
          
          price: pastJob.price || 0,
          deadline: '', 
          deadlineTime: ''
      });

      setActiveTab('new-job');
  };

  // Zorg dat je inlogscherm te zien is wanneer je bent uitgelogd of data laadt
  if (loading) return <div className="h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 text-indigo-600 font-sans"><Loader2 className="w-10 h-10 animate-spin" /><span className="ml-3">Laden...</span></div>;
  if (!user && firebaseInitialized) return <LoginScreen onLogin={handleGoogleLogin} error={null} />;
  if (!firebaseInitialized) return <LoginScreen onLogin={()=>{}} error={firebaseError} />;

  // HIER BEGINT DE ECHTE APP INTERFACE WEER!
  return (
    <div id="app-root">
      <div className="flex h-screen bg-slate-50 dark:bg-slate-900 font-sans text-slate-900 dark:text-white flex-col md:flex-row transition-colors duration-300 no-print">
        
        {/* SIDEBAR MENU */}
        <aside className="hidden md:flex w-20 lg:w-64 flex-col border-r border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 h-screen sticky top-0 justify-between">
           <div>
            <div className="h-16 flex items-center justify-center lg:justify-start lg:px-6 border-b border-slate-100 dark:border-slate-700">
               {/* NIEUW: Dynamisch Logo */}
               <img src={userProfile?.companyLogo || "/logo.png"} alt="Logo" className="w-8 h-8 object-contain mr-3" onError={(e)=>{e.target.src='/logo.png';}}/>
               <span className="hidden lg:block ml-0 font-bold text-lg text-slate-800 dark:text-white">{userProfile?.companyName || 'De Tennis Winkel'}</span>
            </div>
            <nav className="p-4 space-y-2">
              {[
                  { id: 'dashboard', icon: Layout, label: 'Overzicht' }, 
                  { id: 'inbox', icon: Bell, label: 'Aanvragen', badge: inbox.length }, 
                  { id: 'customers', icon: Users, label: 'Klanten' }, 
                  { id: 'new-job', icon: Plus, label: 'Nieuwe Opdracht' }, 
                  { id: 'testrackets', icon: Calendar, label: 'Testrackets' }, 
                  { id: 'inventory', icon: Database, label: 'Materialen' }, 
                  { id: 'all-jobs', icon: Archive, label: 'Archief' },
                  { id: 'statistics', icon: TrendingUp, label: 'Statistieken' },
                  { id: 'settings', icon: Settings, label: 'Instellingen' }
              ].map(item => (
                  <button key={item.id} onClick={() => { setActiveTab(item.id); setSelectedStringerPortal(null); }} className={`flex items-center justify-between w-full p-3 rounded-xl transition-colors ${activeTab === item.id && !selectedStringerPortal ? 'bg-indigo-50 dark:bg-indigo-900/50 text-indigo-600 dark:text-indigo-300' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                      <div className="flex items-center">
                          <item.icon className="w-6 h-6" /><span className="hidden lg:block ml-3 font-medium capitalize">{item.label}</span>
                      </div>
                      {item.badge > 0 && (
                          <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">{item.badge}</span>
                      )}
                  </button>
              ))}
            </nav>
          </div>
        <div className="p-4 border-t border-slate-100 dark:border-slate-700 space-y-2">
              <button onClick={toggleTheme} className="flex items-center w-full p-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                  {darkMode ? <Sun className="w-6 h-6" /> : <Moon className="w-6 h-6" />}
                  <span className="hidden lg:block ml-3 font-medium">{darkMode ? 'Licht' : 'Donker'}</span>
              </button>
              <button onClick={handleLogout} className="flex items-center w-full p-3 rounded-xl text-slate-500 dark:text-slate-400 hover:bg-red-50 dark:hover:bg-red-900/30 hover:text-red-500 dark:hover:text-red-400 transition-colors"><LogOut className="w-6 h-6" /><span className="hidden lg:block ml-3 font-medium">Uitloggen</span></button>
              
              {/* NIEUW: Privacy linkje */}
              <div className="pt-2 text-center lg:text-left lg:px-3">
                  <a href="/support/privacy" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-400 hover:text-indigo-500 dark:hover:text-indigo-400 transition-colors">Privacy Verklaring</a>&nbsp;|&nbsp;
                    <a href="/support/voorwaarden" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-400 hover:text-indigo-500 dark:hover:text-indigo-400 transition-colors">Voorwaarden</a>

              </div>
          </div>
          
        </aside>
        
        {/* HOOFDSCHERM */}
        <main className="flex-1 flex flex-col overflow-hidden relative mb-16 md:mb-0">
            <header className="h-16 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between px-4 md:px-8 relative z-50">
               <div className="flex items-center">
                  {/* NIEUW: Dynamisch Logo voor mobiel */}
                  <img src={userProfile?.companyLogo || "/logo.png"} alt="Logo" className="md:hidden w-8 h-8 object-contain mr-3" onError={(e)=>{e.target.src='/logo.png';}}/>
                  <h2 className="text-lg md:text-xl font-semibold text-slate-800 dark:text-white capitalize truncate max-w-[150px] md:max-w-none">{activeTab.replace('-', ' ')}</h2>
               </div>
               <div className="flex items-center space-x-4">
                  <div className="flex items-center bg-slate-100 dark:bg-slate-800 rounded-full px-4 py-2 relative">
                    <Search className="w-4 h-4 text-slate-400 mr-2" />
                    <input type="text" placeholder="Zoek klant..." className="bg-transparent text-sm outline-none w-32 md:w-48 text-slate-900 dark:text-white placeholder-slate-400" value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setShowGlobalSearchDropdown(true); }} onFocus={() => setShowGlobalSearchDropdown(true)} onBlur={() => setTimeout(() => setShowGlobalSearchDropdown(false), 200)} />
                  {showGlobalSearchDropdown && searchQuery && (
                      <ul className="absolute top-12 right-0 w-64 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 overflow-hidden z-50">
                          {customers.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase())).slice(0, 5).map(c => (
                              <li key={c.id} onClick={() => openCustomerHistory(c)} className="px-4 py-3 hover:bg-slate-50 dark:hover:bg-slate-700/50 cursor-pointer flex items-center border-b border-slate-50 dark:border-slate-700 last:border-0"><div className="w-8 h-8 rounded-full bg-indigo-50 dark:bg-indigo-900/50 text-indigo-600 dark:text-indigo-300 flex items-center justify-center font-bold text-xs mr-3">{c.name.charAt(0)}</div><div className="flex-1"><p className="text-sm font-medium text-slate-800 dark:text-white truncate">{c.name}</p><p className="text-xs text-slate-400">Bekijk historie</p></div></li>
                          ))}
                          {customers.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase())).length === 0 && <li className="px-4 py-3 text-xs text-slate-400 text-center">Geen klanten gevonden</li>}
                      </ul>
                  )}
                  </div>
               </div>
            </header>
            
            <div className="flex-1 overflow-y-auto p-4 md:p-8">
{activeTab === 'dashboard' && (
    <DashboardView 
        jobs={jobs} 
        customers={customers} 
        searchQuery={searchQuery}
        setActiveTab={setActiveTab}
        getCustomerName={getCustomerName}
        getRacketName={getRacketName}
        openCustomerHistory={openCustomerHistory}
        cycleStatus={cycleStatus}
        togglePaid={togglePaid}
        duplicateJob={duplicateJob}
        openJobEditModal={openJobEditModal}
        openPrintModal={openPrintModal}
        selectedJobIds={selectedJobIds}
        toggleJobSelection={toggleJobSelection}
        handleSelectAllJobs={handleSelectAllJobs}
        handleBulkPrintJobs={handleBulkPrintJobs}
        handleBulkDeleteJobs={handleBulkDeleteJobs}
        generateMollieLink={generateMollieLink}
        setPaymentModalJob={setPaymentModalJob}
        generatingMollieId={generatingMollieId}
    />
)}
 {activeTab === 'inbox' && (
  <InboxView 
    inbox={inbox} 
    user={user} 
    onProcessItem={processInboxItem} 
    onDeleteItem={(id) => {
      if (window.confirm("Wil je deze aanvraag definitief verwijderen?")) {
          deleteDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'inbox', id));
      }
      onDirectProcessItem={handleDirectProcessItem}
    }} 
    onDirectProcessItem={handleDirectProcessItem}
  />
)}
               {activeTab === 'inventory' && (
    <InventoryView 
        inventory={inventory}
        inventorySearch={inventorySearch}
        setInventorySearch={setInventorySearch}
        inventoryFilter={inventoryFilter}
        setInventoryFilter={setInventoryFilter}
        selectedInventoryIds={selectedInventoryIds}
        toggleInventorySelection={toggleInventorySelection}
        handleSelectAllInventory={handleSelectAllInventory}
        handleBulkDeleteInventory={handleBulkDeleteInventory}
        handleInventoryExport={handleInventoryExport}
        openItemModal={openItemModal}
        setImportText={setImportText}
        setShowImportModal={setShowImportModal}
        duplicateInventoryGroups={duplicateInventoryGroups}
        isProcessingImport={isProcessingImport}
        mergeAllInventoryGroups={mergeAllInventoryGroups}
        mergeInventoryGroup={mergeInventoryGroup}
    />
)}
                {activeTab === 'all-jobs' && (
    <AllJobsView 
        jobs={jobs}
        customers={customers}
        searchQuery={searchQuery}
        getCustomerName={getCustomerName}
        getRacketName={getRacketName}
        openCustomerHistory={openCustomerHistory}
        togglePaid={togglePaid}
        openPrintModal={openPrintModal}
        openJobEditModal={openJobEditModal}
        selectedJobIds={selectedJobIds}
        toggleJobSelection={toggleJobSelection}
        handleSelectAllJobs={handleSelectAllJobs}
        handleBulkPrintJobs={handleBulkPrintJobs}
        handleBulkDeleteJobs={handleBulkDeleteJobs}
        setImportText={setImportText}
        setShowJobImportModal={setShowJobImportModal}
        generateMollieLink={generateMollieLink}
        setPaymentModalJob={setPaymentModalJob}
        generatingMollieId={generatingMollieId}
    />
)}
                {activeTab === 'customer-history' && (
        <CustomerHistoryView 
        selectedCustomerForHistory={selectedCustomerForHistory}
        jobs={jobs}
        setActiveTab={setActiveTab}
        getRacketName={getRacketName}
        isEditingCustomer={isEditingCustomer}
        startEditingCustomer={startEditingCustomer}
        saveEditedCustomer={saveEditedCustomer}
        editingCustomerData={editingCustomerData}
        setEditingCustomerData={setEditingCustomerData}
        onRepeatJob={handleRepeatJob}
    />
                )}
                {activeTab === 'stringer-portal' && (
    <StringerPortalView 
        selectedStringerPortal={selectedStringerPortal}
        stringers={stringers}
        jobs={jobs}
        customers={customers}
        setSelectedStringerPortal={setSelectedStringerPortal}
        setActiveTab={setActiveTab}
        getCustomerName={getCustomerName}
        getRacketName={getRacketName}
        openCustomerHistory={openCustomerHistory}
        handleBulkPayStringer={handleBulkPayStringer}
        toggleStringerPaid={toggleStringerPaid}
        onUpdateStringerRate={() => {}}
    />
)}
                {activeTab === 'new-job' && (
    <NewJobView 
        customers={customers}
        stringers={stringers}
        inventory={inventory}
        newJob={newJob}
        setNewJob={setNewJob}
        customerSearchTerm={customerSearchTerm}
        setCustomerSearchTerm={setCustomerSearchTerm}
        showCustomerDropdown={showCustomerDropdown}
        setShowCustomerDropdown={setShowCustomerDropdown}
        showRacketDropdown={showRacketDropdown}
        setShowRacketDropdown={setShowRacketDropdown}
        customerPreviousRackets={customerPreviousRackets}
        setCustomerPreviousRackets={setCustomerPreviousRackets}
        stringSearchTerm={stringSearchTerm}
        showStringDropdown={showStringDropdown}
        setShowStringDropdown={setShowStringDropdown}
        crossStringSearchTerm={crossStringSearchTerm}
        showCrossStringDropdown={showCrossStringDropdown}
        setShowCrossStringDropdown={setShowCrossStringDropdown}
        addJob={addJob}
        createQuickCustomer={createQuickCustomer}
        selectCustomerForJob={selectCustomerForJob}
        findLastTensionForRacket={findLastTensionForRacket}
        toggleHybridMode={toggleHybridMode}
        handleManualStringInput={handleManualStringInput}
        selectStringForJob={selectStringForJob}
        handleManualCrossStringInput={handleManualCrossStringInput}
        selectCrossStringForJob={selectCrossStringForJob}
        handleBaseGripChange={handleBaseGripChange}
        handleOverGripChange={handleOverGripChange}
        calculateNewPrice={calculateNewPrice}
    />
                )}
                
{activeTab === 'testrackets' && (
    <TestracketsView 
        user={user}
        testrackets={testrackets}
        customers={customers}
        openCustomerHistory={openCustomerHistory}
        createQuickCustomer={createQuickCustomer}
    />
)}

{activeTab === 'settings' && (
    <SettingsView 
        user={user}
        userProfile={userProfile}
        stringers={stringers}
        jobs={jobs}
        customLinkId={customLinkId}
        draftCompanyName={draftCompanyName}
        setDraftCompanyName={setDraftCompanyName}
        saveCompanyName={saveCompanyName}
        newStringerName={newStringerName}
        setNewStringerName={setNewStringerName}
        addStringer={addStringer}
        deleteStringer={deleteStringer}
        draftLinkId={draftLinkId}
        setDraftLinkId={setDraftLinkId}
        saveCustomLinkId={saveCustomLinkId}
        mollieLiveKey={mollieLiveKey}
        setMollieLiveKey={setMollieLiveKey}
        mollieTestKey={mollieTestKey}
        setMollieTestKey={setMollieTestKey}
        saveMollieKeys={saveMollieKeys}
        setSelectedStringerPortal={setSelectedStringerPortal}
        setActiveTab={setActiveTab}
        setImportText={setImportText}
        setShowJobImportModal={setShowJobImportModal}
        formSettings={formSettings}
        updateFormSettings={updateFormSettings}
        
        // NIEUW: Deze 3 extra opties toegevoegd voor de logo upload
        companyLogo={userProfile?.companyLogo}
        isUploadingLogo={isUploadingLogo}
        onLogoUpload={handleLogoUpload}
    />
)}              
{activeTab === 'customers' && (
   <CustomersView 
       customers={customers}
       newCustomer={newCustomer}
       setNewCustomer={setNewCustomer}
       addCustomer={addCustomer}
       selectedCustomerIds={selectedCustomerIds}
       toggleCustomerSelection={toggleCustomerSelection}
       handleBulkDeleteCustomers={handleBulkDeleteCustomers}
       initiateMerge={() => {}} 
       duplicateGroups={duplicateGroups}
       openCustomerHistory={openCustomerHistory}
       setImportText={setImportText}
       setShowCustomerImportModal={setShowCustomerImportModal}
       confirmMerge={handleConfirmMerge} 
   />
)}
   {activeTab === 'statistics' && (
       <StatisticsView 
        jobs={jobs} 
        customers={customers}
        onMergeClubs={handleMergeClubs}
                />
   )}
   
            </div>
        </main>

      {/* MOBIELE ONDERBALK */}
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 z-50 flex justify-between px-4 py-2 shadow-lg no-print">
           {[
               { id: 'dashboard', icon: Layout, label: 'Overzicht' }, 
               { id: 'inbox', icon: Bell, label: 'Aanvragen', badge: inbox.length },
               { id: 'new-job', icon: Plus, label: 'Nieuwe', highlight: true }, 
               { id: 'testrackets', icon: Calendar, label: 'Testers' }
           ].map(item => (
               <button key={item.id} onClick={() => { setActiveTab(item.id); setShowMobileMenu(false); setSelectedStringerPortal(null); }} className={`flex flex-col items-center justify-center min-w-[50px] p-1 rounded-lg transition-colors relative ${item.highlight ? 'bg-indigo-600 text-white -mt-6 h-14 w-14 rounded-full shadow-lg' : activeTab === item.id && !selectedStringerPortal ? 'text-indigo-600 dark:text-indigo-400' : 'text-slate-400'}`}>
                   <item.icon className={item.highlight ? "w-6 h-6" : "w-6 h-6 mb-1"} /><span className="text-[10px] font-medium">{!item.highlight && item.label}</span>
                   {item.badge > 0 && (
                        <span className="absolute top-0 right-2 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full leading-none">{item.badge}</span>
                   )}
               </button>
           ))}
           <button onClick={() => setShowMobileMenu(!showMobileMenu)} className={`flex flex-col items-center min-w-[50px] p-1 rounded-lg ${showMobileMenu ? 'text-indigo-600' : 'text-slate-400'}`}><MenuIcon className="w-6 h-6 mb-1" /><span className="text-[10px] font-medium">Meer</span></button>
        </div>

        {/* MOBIEL MEER MENU */}
        {showMobileMenu && (
            <div className="md:hidden fixed bottom-20 right-4 w-48 bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-100 dark:border-slate-700 z-50 overflow-hidden animate-in slide-in-from-bottom-5 fade-in duration-200 no-print">
                {[
                    { id: 'customers', icon: Users, label: 'Klanten' },
                    { id: 'inventory', icon: Database, label: 'Materialen' },
                    
                    { id: 'all-jobs', icon: Archive, label: 'Archief' },
                    { id: 'settings', icon: Settings, label: 'Instellingen' }
                ].map(item => (
                    <button key={item.id} onClick={() => { setActiveTab(item.id); setShowMobileMenu(false); setSelectedStringerPortal(null); }} className="w-full text-left px-4 py-3 flex items-center space-x-3 hover:bg-slate-50 dark:hover:bg-slate-700 border-b border-slate-50 dark:border-slate-700 last:border-0"><item.icon className="w-5 h-5 text-slate-500 dark:text-slate-400" /><span className="font-medium text-sm text-slate-700 dark:text-slate-200">{item.label}</span></button>
                ))}
                
                {/* HIERONDER ZIT DE AANPASSING */}
                <div className="p-2 border-t border-slate-100 dark:border-slate-700">
                    <button onClick={toggleTheme} className="flex items-center w-full p-2 rounded-lg text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
                          {darkMode ? <Sun className="w-5 h-5 mr-3" /> : <Moon className="w-5 h-5 mr-3" />}
                          <span className="font-medium text-sm">{darkMode ? 'Licht' : 'Donker'}</span>
                    </button>
                    <button onClick={handleLogout} className="flex items-center w-full p-2 rounded-lg text-slate-500 dark:text-slate-400 hover:bg-red-50 dark:hover:bg-red-900/30 hover:text-red-500 dark:hover:text-red-400 transition-colors"><LogOut className="w-5 h-5 mr-3" /><span className="font-medium text-sm">Uitloggen</span></button>
                    
                    {/* NIEUW: Privacy linkje mobiel */}
                    <div className="pt-3 pb-1 text-center">
                        <a href="/support/privacy" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-400 hover:text-indigo-500 dark:hover:text-indigo-400 transition-colors">Privacy Verklaring</a>&nbsp;|&nbsp;
                        <a href="/support/voorwaarden" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-400 hover:text-indigo-500 dark:hover:text-indigo-400 transition-colors">Voorwaarden</a>
                    </div>
                </div>
            </div>
        )}
        {/* --- GLOBALE MODALS --- */}
        <ItemEditModal 
            editingItem={editingItem} 
            setEditingItem={setEditingItem} 
            saveItem={saveItem} 
        />

        <JobEditModal 
            editingJob={editingJob} 
            setEditingJob={setEditingJob} 
            saveEditedJob={saveEditedJob} 
            stringers={stringers} 
        />

        <PaymentModal 
            paymentModalJob={paymentModalJob} 
            setPaymentModalJob={setPaymentModalJob} 
            paymentMessage={paymentMessage} 
            setPaymentMessage={setPaymentMessage} 
            handleCopyPaymentMessage={handleCopyPaymentMessage} 
            isCopied={isCopied} 
        />

<PrintModal 
    showPrintModal={showPrintModal} 
    setShowPrintModal={setShowPrintModal} 
    jobsToPrint={jobsToPrint} 
    customers={customers} 
    handlePrint={handlePrint} 
    getCustomerName={getCustomerName}
    userName={userProfile?.companyName || user?.displayName || 'Bespanservice'} 
/>

      </div>
    </div>
  );
}

export default function App() {
    React.useEffect(() => {
        const scriptId = 'tailwind-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = "https://cdn.tailwindcss.com";
            document.head.appendChild(script);
            script.onload = () => {
                window.tailwind.config = { darkMode: 'class' };
            };
        }
    }, []);

    const [isAanmelden, setIsAanmelden] = useState(false);
    const [reservationStringerId, setReservationStringerId] = useState<string | null>(null);

    useEffect(() => {
        const handleLocationChange = () => {
            const path = window.location.pathname;
            const searchParams = new URLSearchParams(window.location.search);
            
            // 1. Oude aanmeld flow check
            setIsAanmelden(path === '/aanmelden' || searchParams.get('page') === 'aanmelden');
            
// 2. Nieuwe reserverings flow check via query params
            if (searchParams.get('page') === 'reserveer') {
                const id = searchParams.get('id');
                if (id) {
                    setReservationStringerId(id);
                }
            } else {
                setReservationStringerId(null);
            }
        };
        
        handleLocationChange();
        window.addEventListener('popstate', handleLocationChange);
        return () => window.removeEventListener('popstate', handleLocationChange);
    }, []);

    // Toon de reserveringspagina als we op de juiste link zitten
    if (reservationStringerId) {
        return (
            <ErrorBoundary>
                <ReservationView stringerId={reservationStringerId} />
            </ErrorBoundary>
        );
    }

    // Toon het oude aanmeldformulier
    if (isAanmelden) {
        return (
            <ErrorBoundary>
                <IntakeForm />
            </ErrorBoundary>
        );
    }

    // Toon het normale dashboard
    return (
        <ErrorBoundary>
            <AppContent />
        </ErrorBoundary>
    );
}